import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClientDatamanagementComponent } from './client-datamanagement/client-datamanagement.component';
import { ChatDefaultPageComponent } from './clientcommunication/chat-area/chat-default-page/chat-default-page.component';
import { ChatRoomComponent } from './clientcommunication/chat-area/chat-room/chat-room.component';
import { ClientcommunicationComponent } from './clientcommunication/clientcommunication.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { FrequentlyAskedQuestionsComponent } from './frequently-asked-questions/frequently-asked-questions.component';
import { HowToComponent } from './how-to/how-to.component';
import { LoginComponent } from './login/login.component';
import { TwoFactorApproveComponent } from './two-factor-approve/two-factor-approve.component';
import { LogoutComponent } from './logout/logout.component';
import { ProfileComponent } from './profile/profile.component';
import { ReportsComponent } from './reports/reports.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { RoleComponent } from './role/role.component';
import { AuthGuard } from './services/authguard/auth.guard';
import { PrivilegeGuard } from './services/authguard/privilege.guard';
import { SignupComponent } from './signup/signup.component';
import { SupportTicketsComponent } from './support-tickets/support-tickets.component';
import { UserComponent } from './user/user.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ManageDiscountComponent } from './manage-discount/manage-discount.component';
import { ManageSubscriptionPlanComponent } from './manage-subscription-plan/manage-subscription-plan.component';
import { ManageHolidaysComponent } from './manage-holidays/manage-holidays.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'two-factor-approve', component: TwoFactorApproveComponent },
  { path: 'logout', component: LogoutComponent, canActivate: [AuthGuard] },
  { path: 'signup', component: SignupComponent },
  { path: 'home', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent, },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [AuthGuard],
  },
  { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
  {
    path: 'user', component: UserComponent, canActivate: [AuthGuard, PrivilegeGuard],
    data: { privilege: ['systemadmin_user_create', 'systemadmin_user_modify'] },
  },
  {
    path: 'client-communication',
    component: ClientcommunicationComponent,
    children: [
      {
        path: 'room/:id',
        component: ChatRoomComponent
      },
      {
        path: '',
        component: ChatDefaultPageComponent
      }
    ],
    canActivate: [AuthGuard, PrivilegeGuard],
    data: { privilege: ['businessclient_notification_view'] },
  },
  {
    path: 'client-datamanagement',
    component: ClientDatamanagementComponent,
    canActivate: [AuthGuard, PrivilegeGuard],
    data: { privilege: ['businessclient_datamanagement_view'] },
  },
  {
    path: 'role', component: RoleComponent, canActivate: [AuthGuard, PrivilegeGuard],
    data: { privilege: ['systemadmin_role_create', 'systemadmin_role_modify'] },
  },
  {
    path: 'frequently-asked-questions', component: FrequentlyAskedQuestionsComponent, canActivate: [AuthGuard, PrivilegeGuard],
    data: { privilege: ['businessportal_faq_create', 'businessportal_faq_modify', 'businessportal_faq_delete'] },
  },
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent, canActivate: [AuthGuard] },
  { path: 'privacy-policy', component: PrivacyPolicyComponent, canActivate: [AuthGuard] },
  {
    path: 'support-tickets', component: SupportTicketsComponent, canActivate: [AuthGuard, PrivilegeGuard],
    data: { privilege: ['businessclient_support'] },
  },
  {
    path: 'how-to', component: HowToComponent, canActivate: [AuthGuard, PrivilegeGuard],
    data: { privilege: ['businessportal_howto_create', 'businessportal_howto_modify', 'businessportal_howto_delete'] },
  },
  {
    path: 'reports', component: ReportsComponent, canActivate: [AuthGuard, PrivilegeGuard],
    data: { privilege: ['businessclient_report'] },
  },
  {
    path: 'manage-discount', component: ManageDiscountComponent, canActivate: [AuthGuard, PrivilegeGuard],
    data: { privilege: ['_ALL'] },
  },
  {
    path: 'manage-subscription-plan', component: ManageSubscriptionPlanComponent, canActivate: [AuthGuard, PrivilegeGuard],
    data: { privilege: ['_ALL'] },
  },
  {
    path: 'manage-holidays', component: ManageHolidaysComponent, canActivate: [AuthGuard, PrivilegeGuard],
    data: { privilege: ['_ALL'] },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
